import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PruTableSortTypeEnum } from 'src/app/common/components/PruTable/PruTable';
import { fetchBdmHoldPolicies, FetchBdmHoldPoliciesParams } from 'src/app/modules/OpmPd/network/opm-pd-bdm';
import { BdmHoldPolicyListItem } from 'src/app/modules/OpmPd/types/opm-pd-bdm-types';
import { isEmpty } from 'src/app/modules/OpmPd/utils/commonHelper';

const initialState: FetchBdmHoldPoliciesParams = {
  page: 1,
  limit: 5,
};

const paramsInitiator = (initialParams?: Record<string, string>): FetchBdmHoldPoliciesParams => {
  return initialParams
    ? {
        page: 1,
        limit: 5,
        ...initialParams,
      }
    : initialState;
};

export const useHoldPolicyListApi = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<FetchBdmHoldPoliciesParams>(paramsInitiator(initialParams));
  const [holdPolicies, setHoldPolicies] = useState<PaginateList<BdmHoldPolicyListItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<BdmHoldPolicyListItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }

        const params = Object.fromEntries(Object.entries(filterState).filter(([, v]) => !isEmpty(v))) as any;
        return await fetchBdmHoldPolicies(params, dispatch);
      } catch (err) {}
    },
    setHoldPolicies,
    false,
  );

  const onSort = (newSortState: { key: string; value?: string }) => {
    const { key, value } = newSortState;
    if (value) {
      let newSort = '';
      switch (value) {
        case PruTableSortTypeEnum.ASC:
          newSort = key;
          break;
        case PruTableSortTypeEnum.DESC:
          newSort = `-${key}`;
          break;
      }
      setFilterState({ ...filterState, sort: newSort });
    } else {
      setFilterState({ ...filterState, sort: undefined });
    }
    refreshData();
  };

  return {
    filterState,
    holdPolicies,
    isLoading,
    setFilterState,
    refreshData,
    onSort,
  };
};
